import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { GlobalService, HttpServiceBase, AuthorizationHelperService, AppSettings } from "@nordpoolgroup/nps-angular-2-common";

import { IAction, IServiceAdapter } from "./IServiceAdapter";
import { IContractData } from "./IContractData";
import { IContractEditData } from "./IContractData";
import {TenantService} from "./TenantService";
import {ConfirmationService} from "primeng/primeng";
import {ContractState} from "../ContractDataModels";

@Injectable()
export abstract class ServiceAdapter<TContractStatus> extends HttpServiceBase implements IServiceAdapter<TContractStatus> {
    protected readonly abstract contractsApiPath: string;
    readonly abstract availableActions: IAction<TContractStatus>[];
    abstract save(changedContractAreas: IContractEditData[], marketAreaCodes: string[]): Promise<any>;
    abstract getContracts(): Promise<IContractData[]>;
    abstract isContractStatusEditable(status: TContractStatus): boolean;

    constructor(
        http: Http,
        globalService: GlobalService,
        authorizationHelperService: AuthorizationHelperService,
        private tenantService: TenantService,
        protected confirmationService: ConfirmationService
    ) {
        super(
            http,
            globalService,
            authorizationHelperService,
            "",
            AppSettings.systemConfiguration.ApiAddress
        );
    }

    protected makeGetContractsRequest(): Promise<IContractData[]> {
        const tenantId = this.getCurrentTenantId();

        // Since we're showing in CET and requesting in UTC need to set the CET offset to start of day in zulu/UTC-time:
        const CetToZulutimetOffsetHours = -1;
        const startTime = encodeURIComponent(moment().utc().startOf("day").add(CetToZulutimetOffsetHours, "hours").toISOString());
        const endTime = encodeURIComponent(moment().add(1, "days").utc().endOf("day").add(CetToZulutimetOffsetHours + 1, "hours").toISOString());

        const uri = `${this.contractsApiPath}?tenantId=${tenantId}&startZuluTime=${startTime}&endZuluTime=${endTime}`;

        return super.get<IContractData[]>(uri);
    }

    protected getAllTenants(): string[] {
        return this.tenantService.getAllTenants();
    }

    protected getCurrentTenantId(): string {
        return this.tenantService.currentTenantId;
    }

    protected isXbidTenant(): boolean {
        return this.tenantService.isXbidTenant;
    }

    contractManagementRequest(action: ContractState): Promise<any> {
        return Promise.resolve();
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/ServiceAdapter.ts